
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTimeGoogle as ObiTimeGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-time-google.js';
 
 
 

 
 export const ObiTimeGoogle = createComponent({
   react: React,
   tagName: 'obi-time-google',
   elementClass: ObiTimeGoogleElement,
   events: {
     
   }
  });
 
 